jQuery(function ($) {
  function updateCheckboxVisibility() {
    const $a1 = $("#a1_has");
    const $tuv = $("#tuv_has");

    console.log("A1 checked:", $a1.is(":checked"));
    console.log("TUV checked:", $tuv.is(":checked"));

    if ($a1.is(":checked")) {
      console.log("Pokazuję #a1_countries_wrap");
      $("#a1_countries_wrap").show();
    } else {
      console.log("Ukrywam #a1_countries_wrap");
      $("#a1_countries_wrap").hide();
    }

    if ($tuv.is(":checked")) {
      console.log("Pokazuję #tuv_until_wrap");
      $("#tuv_until_wrap").show();
    } else {
      console.log("Ukrywam #tuv_until_wrap");
      $("#tuv_until_wrap").hide();
    }
  }

  // Log initial state on page load
  updateCheckboxVisibility();

  $("#a1_has").on("change", updateCheckboxVisibility);
  $("#tuv_has").on("change", updateCheckboxVisibility);

  $("#application-form").on("submit", function (e) {
    e.preventDefault();

    let formData = $(this).serializeArray();
    let dataObj = {};

    formData.forEach(function (item) {
      dataObj[item.name] = item.value;
    });

    console.log("Wysyłam dane:", dataObj);

    $("#form-response").html(themeSettings.ajax.messages.sending);

    let dataToSend = $.extend(
      {
        action: "submit_application_form",
      },
      dataObj
    );

    $.post(themeSettings.ajax.url, dataToSend, function (response) {
      console.log("Odpowiedź AJAX:", response);

      if (response.success) {
        $("#form-response").html(
          '<div class="form-success">' +
            themeSettings.ajax.messages.success +
            "</div>"
        );
        $("#a1_countries_wrap, #tuv_until_wrap").hide();
      } else {
        $("#form-response").html(
          '<div class="form-error">' +
            (response.data || themeSettings.ajax.messages.error) +
            "</div>"
        );
      }
    });
  });

  $(document).on("click", ".custom-checkbox", function (e) {
    console.log("Kliknięto .custom-checkbox");

    const $checkbox = $(this).find('input[type="checkbox"]');
    e.preventDefault();

    if (!$(e.target).is("input")) {
      $checkbox.prop("checked", !$checkbox.prop("checked")).trigger("change");
    }
  });
});



// WEBPACK FOOTER //
// ./resources/assets/js/partials/application-form.js